import React from 'react';
import "./SectionArticle.scss";
import { Article, TitleSecondary } from '..';

const SectionArticle = () => {
    return (
        <div className="section-article">
            <TitleSecondary>Blog</TitleSecondary>
            <div className="section-article--articles">
                <Article
                    image="https://images.pexels.com/photos/5257319/pexels-photo-5257319.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    title="Como usar la plataforma"
                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint dicta temporibus aperiam. Labore possimus quod placeat, dignissimos ab incidunt aut voluptatem? Sit ab asperiores fugiat optio animi, dolore autem, veritatis dolores aliquam quo corrupti libero aliquid minima itaque facilis enim."
                    img="https://images.pexels.com/photos/5257319/pexels-photo-5257319.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                />

                <Article
                    image="https://images.pexels.com/photos/6932375/pexels-photo-6932375.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    title="Siendo mas productiva"
                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint dicta temporibus aperiam. Labore possimus quod placeat, dignissimos ab incidunt aut voluptatem? Sit ab asperiores fugiat optio animi, dolore autem, veritatis dolores aliquam quo corrupti libero aliquid minima itaque facilis enim."
                    img="https://images.pexels.com/photos/6932375/pexels-photo-6932375.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                />
                <Article
                    image="https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    title="Elegi la persona adecuada"
                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint dicta temporibus aperiam. Labore possimus quod placeat, dignissimos ab incidunt aut voluptatem? Sit ab asperiores fugiat optio animi, dolore autem, veritatis dolores aliquam quo corrupti libero aliquid minima itaque facilis enim."
                    img="https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                />
                <Article
                    image="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    title="3 tips de carpinteria"
                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint dicta temporibus aperiam. Labore possimus quod placeat, dignissimos ab incidunt aut voluptatem? Sit ab asperiores fugiat optio animi, dolore autem, veritatis dolores aliquam quo corrupti libero aliquid minima itaque facilis enim."
                    img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    
                />
            </div>
        </div>
    )
}

export default SectionArticle;
